import { render, staticRenderFns } from "./AccessGroups.vue?vue&type=template&id=575b789a&scoped=true"
import script from "./AccessGroups.vue?vue&type=script&lang=js"
export * from "./AccessGroups.vue?vue&type=script&lang=js"
import style0 from "./AccessGroups.vue?vue&type=style&index=0&id=575b789a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575b789a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VList,VSpacer,VToolbar,VToolbarTitle})
